module.exports = __webpack_public_path__ + "static/media/progress-bar-body.655a15c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/progress-bar-body.svg
// module id = 975
// module chunks = 0